import type { BadgeTone } from '@/components/ui';

import type { DeliveryStatus } from './contracts';

/** Every node of `core.deliveries.status`, in the order SPRINT07.md's data model lists them. */
export const DELIVERY_STATUSES: readonly DeliveryStatus[] = [
  'pending',
  'preparing',
  'dispatched',
  'delivered',
  'failed',
  'cancelled',
] as const;

/** pt-BR labels for `core.deliveries.status`. */
const STATUS_LABELS: Readonly<Record<DeliveryStatus, string>> = {
  pending: 'Aguardando separação',
  preparing: 'Em separação',
  dispatched: 'Despachado',
  delivered: 'Entregue',
  failed: 'Falhou',
  cancelled: 'Cancelado',
};

const STATUS_TONES: Readonly<Record<DeliveryStatus, BadgeTone>> = {
  pending: 'neutral',
  preparing: 'warning',
  dispatched: 'info',
  delivered: 'success',
  failed: 'danger',
  cancelled: 'neutral',
};

/**
 * A delivery in one of these never moves on its own again — the tenant tracking screen
 * (`features/tracking`) reads this to decide what still counts as "open", the same way
 * `isPaymentStatusFinal` decides what a payment screen keeps polling for.
 */
const TERMINAL_STATUSES: ReadonlySet<DeliveryStatus> = new Set([
  'delivered',
  'failed',
  'cancelled',
]);

export function deliveryStatusLabel(status: DeliveryStatus): string {
  return STATUS_LABELS[status];
}

export function deliveryStatusTone(status: DeliveryStatus): BadgeTone {
  return STATUS_TONES[status];
}

export function isDeliveryStatusFinal(status: DeliveryStatus): boolean {
  return TERMINAL_STATUSES.has(status);
}
